import { render, staticRenderFns } from "./QuickFiltersColumn.vue?vue&type=template&id=2bc92368"
import script from "./QuickFiltersColumn.vue?vue&type=script&lang=js"
export * from "./QuickFiltersColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports